import { render } from "./ProjectList.vue?vue&type=template&id=39b4cabc&scoped=true"
import script from "./ProjectList.vue?vue&type=script&lang=js"
export * from "./ProjectList.vue?vue&type=script&lang=js"

import "./ProjectList.vue?vue&type=style&index=0&id=39b4cabc&scoped=true&lang=css"

import exportComponent from "/app/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39b4cabc"]])

export default __exports__